const BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;

export interface Counter {
  user_id: string | null;
  counter_name: string;
  value: number;
  metadata: Record<string, unknown>;
}

export interface CounterAggregate {
  counter_name: string;
  total: number;
}

class CountersProvider {
  private async request<T>(path: string, options?: RequestInit): Promise<T> {
    const res = await fetch(`${BASE_URL}${path}`, {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });

    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
      throw new Error("Unauthorized");
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "Unknown error");
      throw new Error(text || `HTTP ${res.status}`);
    }

    const text = await res.text();
    try {
      return JSON.parse(text) as T;
    } catch {
      return text as unknown as T;
    }
  }

  getGlobalCounters(): Promise<Counter[]> {
    return this.request<Counter[]>(`/v1/admin/counters`);
  }

  getCounterNames(): Promise<string[]> {
    return this.request<string[]>(`/v1/admin/counter_names`);
  }

  getUserCounters(userId: string): Promise<Counter[]> {
    return this.request<Counter[]>(
      `/v1/admin/users/${encodeURIComponent(userId)}/counters`
    );
  }

  getAggregateCounters(pattern: string): Promise<CounterAggregate[]> {
    const params = pattern ? `?pattern=${encodeURIComponent(pattern)}` : "";
    return this.request<CounterAggregate[]>(`/v1/admin/counters/aggregate${params}`);
  }
}

export const countersProvider = new CountersProvider();
